import Vue from "vue";
import Vuex from "vuex";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { actions } from "./actions";

Vue.use(Vuex);
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
var ls = new SecureLS({ isCompression: false });

export const store = new Vuex.Store({
  plugins: [
    createPersistedState({
      key: "xyz123",
      paths: ["datauser", "usuario"],
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
    }),
  ],
  state: {
    datauser: {
      token: null,
    },
    usuario: null,
    itemsMenuFull: [
      {
        id: "servicios",
        label: "messages.services",
        to: "",
        role: ["user", "admin", "superadmin", "public"],
        items: [
          {
            label: "messages.ourServices",
            to: "/services-main",
            role: ["admin", "user", "superadmin", "public"],
          },
          {
            label: "messages.surgeries",
            to: "/servicios-cirugias",
            role: ["admin", "user", "superadmin", "public"],
          },
          {
            label: "messages.surgeonWellness",//"Bienestar del cirujano"
            to: "/bienestar-cirujanos",
            role: ["admin", "user", "superadmin", "public"],
          },
          {
            label: "messages.patientWellness", //"Bienestar del paciente",
            to: "/bienestar-pacientes",
            role: ["admin", "user", "superadmin", "public"],
          },
        ],
      },
      {
        id: "instalaciones",
        label: "messages.facilities",//"Instalaciones
        to: "/instalaciones",
        role: ["user", "admin", "superadmin", "public"],
        items: [],
      },
      {
        id: "listadoespecialistas",
        label: "messages.specialistList",//"Especialistas
        to: "/listado-especialistas",
        role: ["user", "admin", "superadmin", "public"],
        items: [],
      },
      {
        id: "nosotros",
        label: "messages.aboutUs",//"Nosotros
        to: "/nosotros",
        role: ["user", "admin", "superadmin", "public"],
        items: [],
      },
      {
        id: "blog",
        label: "messages.blog",//"Blog
        to: "/blog",
        role: ["user", "admin", "superadmin", "public"],
        items: [],
      },
      {
        id: "contactenos",
        label: "messages.contactUs",//"Contáctenos
        to: "/registrate",
        role: ["user", "admin", "superadmin", "public"],
        items: [],
      },
      {
        id: "cotizador",
        label: "messages.quotations",//"Cotizador
        to: "/cotizacion",
        role: ["user", "admin", "superadmin"],
        items: [],
      },
      {
        id: "informacion",
        label: "messages.information",//"Información
        to: "/informacion",
        role: ["user", "admin", "superadmin"],
        items: [],
      },
      {
        id: "administracion",
        label: "messages.administration",//"Administración
        role: ["admin", "superadmin"],
        to: "",
        items: [
          {
            label: "messages.users",//"Usuarios
            to: "/usuarios_admin",
            role: ["admin", "superadmin"],
          },
          /* {
            label: i18n.t("Reservas",
            to: "/reservas_admin",
            role: ["admin", "superadmin"],
          }, */
          {
            label: "messages.specialties",//"Especialidades
            to: "/especialidades_admin",
            role: ["admin", "superadmin"],
          },
          {
            label: "messages.surgeries",//"Cirugias
            to: "/cirugias_admin",
            role: ["admin", "superadmin"],
          },
          {
            label: "messages.rates",//"Tarifas
            to: "/tarifas_admin",
            role: ["superadmin"],
          },
          {
            label: "messages.insurers",//Aseguradoras
            to: "/aseguradoras",
            role: ["admin", "superadmin"],
          },
          {
            label: "messages.documents",//Documentos
            to: "/documentos",
            role: ["admin", "superadmin"],
          },
          {
            label: "messages.articles",//Artículos del blog
            to: "/articulos_admin",
            role: ["admin", "superadmin"],
          },
          {
            label: "messages.quotations",//Cotizaciones
            to: "/cotizaciones_admin",
            role: ["admin", "superadmin"],
          },
          /* {
            label: "messages.policies",//"Polizas
            to: "/polizas",
            role: ["admin", "superadmin"],
          }, */
        ],
      },
      /* {
        id: "ppdp",
        label: "Politicas de protección de datos personales",
        to: "/ppdp",
        role: ["user", "admin", "superadmin", "public"],
        items: [],
      }, */
    ],
    permisos: { crearUsuarios: false },
  },
  mutations,
  actions,
  getters,
});
